import { render } from "./invoicefilter.vue?vue&type=template&id=cb2c4996"
import script from "./invoicefilter.vue?vue&type=script&lang=js"
export * from "./invoicefilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__